import { NeuDropdown } from "./NeuDropdown";

// صف المرشّحات المنسدلة بثيم التطبيق: «كل الحالات» + مرشّح ثانٍ حسب التبويب.
export const FilterRow = ({ filters, testid = "filter-row" }) => (
  <div className="grid gap-3 sm:grid-cols-2" data-testid={testid}>
    {filters.map(({ key, value, onChange, options, allLabel }) => (
      <NeuDropdown
        key={key}
        testid={`${testid}-${key}`}
        value={value}
        onChange={onChange}
        placeholder={allLabel}
        options={[{ value: "", label: allLabel }, ...options]}
      />
    ))}
  </div>
);
